import "bootstrap-icons/font/bootstrap-icons.css";
import { useEffect, useState } from "react";
import { FiArrowLeft } from "react-icons/fi";
import { useIntl } from "react-intl";
import { shallowEqual, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import SweetAlert2 from "react-sweetalert2";
import { Overlay } from "../../../common/components/Overlay";
import { VipDownline } from "./VipDownline";
import { VipHome } from "./VipHome";
import { VipReport } from "./VipReport";

const navClass =
  "w-20 d-flex flex-column align-items-center justify-content-center bottom-nav-item";

export const Vip = () => {
  const [swalProps, setSwalProps] = useState({});
  const intl = useIntl();
  const settingState = useSelector(({ setting }) => setting, shallowEqual);
  const [vipTab, setVipTab] = useState("home");

  useEffect(() => {
    const myEvent = new CustomEvent("manageNavBar", {
      detail: {
        value: false,
      },
    });

    window.dispatchEvent(myEvent);

    return () => {
      const myEvent = new CustomEvent("manageNavBar", {
        detail: {
          value: true,
        },
      });

      window.dispatchEvent(myEvent);
    };
  }, []);

  return (
    <div>
      <div style={styles.navBar} className="position-relative">
        <div style={styles.backButton}>
          <Link to="/setting/profile">
            <FiArrowLeft style={{ color: "white" }} />
          </Link>
        </div>
        <div style={styles.title} className="text-font4">
          {intl.formatMessage({ id: "vip" })}
        </div>
      </div>
      {settingState.actionsLoading && <Overlay />}
      <SweetAlert2
        heightAuto={false}
        customClass="custom-swal"
        onResolve={() => {
          setSwalProps({});
        }}
        {...swalProps}
      />
      <div
        style={{
          width: "95%",
          margin: "10px auto",
          padding: "5px",
          color: "white",
          fontSize: "12px",
          borderRadius: "5px",
        }}
      >
        {vipTab === "home" ? (
          <VipHome setSwalProps={setSwalProps} />
        ) : vipTab === "report" ? (
          <VipReport setSwalProps={setSwalProps} />
        ) : (
          <VipDownline setSwalProps={setSwalProps} />
        )}
      </div>
      <div style={{ height: "53px" }} />
      <div className="text-white d-flex bg-dark py-1 shadow justify-content-between position-fixed bottom-0 start-0 end-0">
        <div
          className={`${navClass} ${vipTab === "home" ? "active" : ""}`}
          onClick={() => setVipTab("home")}
        >
          <img
            className="bottom-nav-icon"
            src={`${process.env.PUBLIC_URL}/image/icon/games.avif`}
          />
          <div>{intl.formatMessage({ id: "home" })}</div>
        </div>
        <div
          className={`${navClass} ${vipTab === "report" ? "active" : ""}`}
          onClick={() => setVipTab("report")}
        >
          <img
            className="bottom-nav-icon"
            src={`${process.env.PUBLIC_URL}/image/icon/results.avif`}
          />
          <div>{intl.formatMessage({ id: "report" })}</div>
        </div>
        <div
          className={`${navClass} ${vipTab === "downline" ? "active" : ""}`}
          onClick={() => setVipTab("downline")}
        >
          <img
            className="bottom-nav-icon"
            src={`${process.env.PUBLIC_URL}/image/icon/profile.avif`}
          />
          <div>{intl.formatMessage({ id: "downline" })}</div>
        </div>
      </div>
    </div>
  );
};

const styles = {
  navBar: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    height: "60px",
    backgroundColor: "black",
  },
  backButton: {
    position: "absolute",
    left: "10px",
    fontSize: "20px",
  },
  title: {
    fontWeight: "bold",
    color: "white",
  },
};
